import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { Router } from '@angular/router';
import { fuseAnimations } from '../../../../../../core/animations';
import { AuthenticationService } from '../../../../../services/authentication/authentication.service';
import { DivisionService } from '../../../../../services/divisions/division.service';
import { ShiftService } from '../../../../../services/shifts/shift.service';
import { SweetAlertService } from '../../../../../services/sweet-alert/sweet-alert.service';
import { FormBuilder, Validators } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { EventTypeService } from '../../../../../services/event-types/event-type.service';
import { EventTypeDto } from '../../../../../models/event-types/eventTypeDto';
import { EventService } from '../../../../../services/events/event.service';

@Component({
    selector: 'fuse-add-edit-school-schedule',
    templateUrl: 'add-edit-school-schedule.component.html',
    styleUrls: ['./add-edit-school-schedule.component.scss'],
    animations: fuseAnimations
})
export class AddEditSchoolScheduleComponent implements OnInit, OnDestroy {
    @BlockUI('tracker-dialog') blockUIList: NgBlockUI;
    // form-group
    formGroup;
    // form-controls
    titleFormControl;
    startDateFormControl;
    finishDateFormControl;
    eventTypeFormControl;
    shiftFormControl;
    public minHoraStart: Date;
    public minHoraFinish: Date;
    public eventTypes: EventTypeDto[] = [];
    public shifts: any[];

    ngOnDestroy(): void {
    }

    ngOnInit(): void {
        console.log('data>>>>>>>>>', this.data);
        Observable.combineLatest(this.eventTypeService.getAll(), this.shiftService.getAll()).subscribe(([eventTypes, shifts]) => {
            this.eventTypes = eventTypes;
            this.shifts = shifts;
        });
        if (this.data.mode === 'view') {
            this.disable();
        }
    }

    disable() {
        this.formGroup.get('titleFormControl').disable();
        this.formGroup.get('startDateFormControl').disable();
        this.formGroup.get('finishDateFormControl').disable();
        this.formGroup.get('eventTypeFormControl').disable();
        this.formGroup.get('shiftFormControl').disable();
    }

    constructor(private authenticationService: AuthenticationService,
                @Inject(MAT_DIALOG_DATA) public data: any,
                public dialogRef: MatDialogRef<AddEditSchoolScheduleComponent>,
                public dialog: MatDialog,
                public divisionService: DivisionService,
                public shiftService: ShiftService,
                private router: Router,
                private fb: FormBuilder,
                private eventTypeService: EventTypeService,
                private eventService: EventService,
                private sweetAlertService: SweetAlertService) {
        this.initializeFormControlValidators();
    }

    initializeFormControlValidators() {
        this.formGroup = this.fb.group({
            titleFormControl: ['', [Validators.required]],
            startDateFormControl: ['', [Validators.required]],
            finishDateFormControl: ['', [Validators.required]],
            eventTypeFormControl: ['', [Validators.required]],
            shiftFormControl: ['', [Validators.required]],
        });
    }

    checkValidationErrors() {
        setTimeout(() => {
        }, 20);
    }

    save() {
        this.blockUIList.start('Guardando datos...');
        console.log('this.data.schoolScheduleEvent>>>>>>>>', this.data.schoolScheduleEvent);
        this.eventService.addSchoolSchedule(this.data.schoolScheduleEvent).subscribe(e => {
            const index = this.eventService.events.findIndex(ev => ev.Id === e.Schedule.Id);
            e.Schedule.FinishDate = new Date(e.Schedule.FinishDate + 'Z');
            e.Schedule.StartDate = new Date(e.Schedule.StartDate + 'Z');
            if (index !== -1) {
                this.eventService.events[index] = e.Schedule;
            } else {
                this.eventService.events.push(e.Schedule);
            }
            this.eventService.eventsObject[e.Schedule.Id] = e.Schedule;
            console.log('this.eventService.events', this.eventService.events);

            this.data.schoolScheduleEvent.Id = e.Id;
            this.data.schoolScheduleEvent.EventType = this.eventTypes.find(et => et.Id === this.data.schoolScheduleEvent.EventTypeId).Name;
            this.blockUIList.stop();
            this.dialogRef.close(this.data.schoolScheduleEvent);
        }, error1 => {
            this.blockUIList.stop();
        });

    }

    public calculaMinDate() {
        const fechaInicio = new Date(2018, 0, 1, this.data.schoolScheduleEvent.StartDate.getHours(), this.data.schoolScheduleEvent.StartDate.getMinutes(), this.data.schoolScheduleEvent.StartDate.getSeconds());
        this.data.schoolScheduleEvent.StartDate = fechaInicio;
        this.minHoraFinish = this.data.schoolScheduleEvent.StartDate;
    }

    public calculaMinDateFin() {
        const fechaInicio = new Date(2018, 0, 1, this.data.schoolScheduleEvent.FinishDate.getHours(), this.data.schoolScheduleEvent.FinishDate.getMinutes(), this.data.schoolScheduleEvent.FinishDate.getSeconds());
        this.data.schoolScheduleEvent.FinishDate = fechaInicio;
        this.minHoraStart = this.data.schoolScheduleEvent.FinishDate;
    }
}



// WEBPACK FOOTER //
// ./src/app/main/content/pages/events/school-schedule/add-edit-school-schedule/add-edit-school-schedule.component.ts